module.exports = __webpack_public_path__ + "static/media/register.afb26014.jpg";